import { Trash2 } from 'lucide-react';

import { ProtectedComponent } from '@/components/ProtectedComponent';
import { DropdownAction } from '@/components/ui/dropdown-actions';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';

import { useDeleteApiKeyMutation } from '@/query/api-key.query';

import { Permissions } from '@/constants';

import useAlertStore from '@/store/alert.store';
import type { ApiKey } from '@/types/api-key.type';

type Props = {
  apiKey: ApiKey;
};

export const RowAction = ({ apiKey }: Props) => {
  const openAlert = useAlertStore(s => s.openAlert);
  const mutation = useDeleteApiKeyMutation();

  const handleRevoke = (e: React.MouseEvent) => {
    e.stopPropagation();
    openAlert({
      title: 'Revoke API Key',
      description: 'Are you sure you want to revoke this API key? This action cannot be undone.',
      confirmText: 'Revoke',
      onConfirm: async () => {
        await mutation.mutateAsync(apiKey.id);
      },
      type: 'destructive',
    });
  };

  return (
    <ProtectedComponent requiredPermissions={[Permissions.ApiKeyDelete]}>
      <DropdownAction>
        <DropdownMenuItem variant="destructive" onClick={handleRevoke}>
          <Trash2 className="h-4 w-4" />
          Revoke
        </DropdownMenuItem>
      </DropdownAction>
    </ProtectedComponent>
  );
};
